import React, { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { MenuItem } from "@mui/material";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput"; // Importar MDInput
import MDSnackbar from "components/MDSnackbar"; // Importar MDSnackbar
import CreditSummaryModal from "./components/CreditSummaryModal";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Context
// import { useCart } from "context/CartContext"; // Importar useCart

function Planes() {
  const [selectedQuantity, setSelectedQuantity] = useState(1); // Estado para la cantidad seleccionada
  const PRICE_PER_CREDIT = 1000; // Precio por crédito en COP
  const TEST_NAME = "Quadrante H"; // Nombre del test

  const totalPrice = selectedQuantity * PRICE_PER_CREDIT; // Calcular precio total
  // const [, dispatch] = useCart(); // Usar el hook useCart para obtener el dispatch
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    color: "success",
  });
  const [openCreditSummaryModal, setOpenCreditSummaryModal] = useState(false);

  // Función para mostrar notificaciones
  const showNotification = (message, color = "success") => {
    setNotification({
      open: true,
      message,
      color,
    });
  };

  // Función para cerrar notificaciones
  const closeNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  const handleOpenCreditSummaryModal = () => setOpenCreditSummaryModal(true);
  const handleCloseCreditSummaryModal = () => setOpenCreditSummaryModal(false);

  const handleIncreaseCredits = () => {
    setSelectedQuantity((prevQuantity) => Math.min(prevQuantity + 1, 50));
  };

  const handleDecreaseCredits = () => {
    setSelectedQuantity((prevQuantity) => Math.max(prevQuantity - 1, 1));
  };

  // Función para generar las opciones de cantidad (1 a 50)
  const generateQuantityOptions = () => {
    const options = [];
    for (let i = 1; i <= 50; i++) {
      options.push({
        value: i,
        label: i,
      });
    }
    return options;
  };

  const handleAddToCart = () => {
    // dispatch({
    //   type: "SET_CREDITS",
    //   payload: selectedQuantity,
    // });
    // showNotification(`Agregado: ${selectedQuantity} créditos por ${totalPrice.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}`, "success");
    console.log("Planes.js - Added to cart:", selectedQuantity, "credits for", totalPrice);
    showNotification(`Seleccionado: ${selectedQuantity} créditos por ${totalPrice.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}`, "info");
    handleOpenCreditSummaryModal();
  };

  const formatCurrency = (value) => {
    return value.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Compra de Créditos ({TEST_NAME})
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <MDTypography variant="body2" color="text" mb={3}>
                  Selecciona la cantidad de créditos del Test &quot;{TEST_NAME}&quot; que deseas adquirir. Cada crédito equivale a 1.000 COP.
                </MDTypography>

                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} md={6} lg={4}>
                    <MDInput
                      select
                      label="Cantidad de Créditos"
                      fullWidth
                      value={selectedQuantity}
                      onChange={(e) => setSelectedQuantity(e.target.value)}
                      sx={{
                        mb: 2,
                        '& .MuiSelect-select': {
                          textAlign: 'left',
                          padding: '16px 14px',
                          minHeight: '48px'
                        },
                        '& .MuiInputBase-root': {
                          minHeight: '56px'
                        }
                      }}
                    >
                      {generateQuantityOptions().map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label} {option.label === 1 ? "crédito" : "créditos"}
                        </MenuItem>
                      ))}
                    </MDInput>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <MDTypography variant="h5" fontWeight="bold" color="text">
                      Total: {formatCurrency(totalPrice)}
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <MDButton variant="gradient" color="info" fullWidth onClick={handleAddToCart}>
                      Agregar 
                    </MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Notificaciones */}
      <MDSnackbar
        color={notification.color}
        icon="notifications"
        title="Notificación"
        content={notification.message || ""}
        dateTime={new Date().toLocaleTimeString()}
        open={notification.open}
        onClose={closeNotification}
        close={closeNotification}
        bgWhite
      />

      <CreditSummaryModal
        open={openCreditSummaryModal}
        onClose={handleCloseCreditSummaryModal}
        selectedQuantity={selectedQuantity}
        totalPrice={totalPrice}
        onIncreaseCredits={handleIncreaseCredits}
        onDecreaseCredits={handleDecreaseCredits}
      />
    </DashboardLayout>
  );
}

export default Planes;